import { ArtifactListOverview } from "@/components/artifacts-list/artifacts-list-overview";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/dashboard/artifacts")({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.artifacts_title()) }],
	}),
});

function RouteComponent() {
	return <ArtifactListOverview />;
}
